export const productViewOptions = [
  {
    value: 'list',
    label: 'List'
  },
  {
    value: 'tile',
    label: 'Tile'
  }
]
